export enum FeedbackFormType {
    INTERVIEW_FEEDBACK = "INTERVIEW_FEEDBACK",
    CASE_FEEDBACK = "CASE_FEEDBACK",
    GENERAL_FEEDBACK = "GENERAL_FEEDBACK",
    USER_EXPERIENCE = "USER_EXPERIENCE",
    TECHNICAL_SUPPORT = "TECHNICAL_SUPPORT",
}

export const FEEDBACK_FORM_TITLES = {
    TECHNICAL_SUPPORT: "Technical Support",
} as const;

export interface FeedbackQuestion {
    id: string;
    question: string;
    type: "text" | "multiple_choice" | "rating" | "scale";
    isRequired: boolean;
    options?: {
        id: string;
        text: string;
    }[];
    selectionType?: "single" | "multiple";
}

export interface FeedbackForm {
    id: string;
    title: string;
    description: string;
    type: FeedbackFormType;
    questions: FeedbackQuestion[];
    createdAt: Date;
    updatedAt: Date;
}

export interface FeedbackResponse {
    questionId: string;
    value: string | string[];
}

export interface FeedbackSubmission {
    formId: string;
    userId: string;
    responses: FeedbackResponse[];
    submittedAt: Date;
}
